// extracted by mini-css-extract-plugin
module.exports = {"search":"Search__search","submitButton":"Search__submitButton","globalSearch":"Search__globalSearch","loadingSpinner":"Search__loadingSpinner"};